import { environment } from "src/environments/environment";

export const userReadWriteGroups = {
  DLI: environment.readWriteGroups, // SJP-AmigoWeb-ReadWrite
  CONTACT: environment.readWriteContactsGroups // Amigo Trafikledning Admin
};
// If empty, assume all have read access
export const userReadGroups = {
};
